__turbopack_context__.v({
  "blogItem": "Blog-module-scss-module__S4QzVG__blogItem",
  "blogList": "Blog-module-scss-module__S4QzVG__blogList",
  "dark": "Blog-module-scss-module__S4QzVG__dark",
  "date": "Blog-module-scss-module__S4QzVG__date",
  "description": "Blog-module-scss-module__S4QzVG__description",
  "details": "Blog-module-scss-module__S4QzVG__details",
  "divider": "Blog-module-scss-module__S4QzVG__divider",
  "light": "Blog-module-scss-module__S4QzVG__light",
  "thumbnail": "Blog-module-scss-module__S4QzVG__thumbnail",
  "title": "Blog-module-scss-module__S4QzVG__title",
});
